import { render, staticRenderFns } from "./CustomTemplate.vue?vue&type=template&id=e54e0ca2&scoped=true&"
import script from "./CustomTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e0ca2",
  null
  
)

export default component.exports